<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "ReadyToFilmList",
  data() {
    return {
      sorting: "",
      activities: [],
      limit: 25,
      currentPageNumber: 1,
      searchStr: null,
      searchResult: true,
      rows: 3,
      fields: [
        {
          key: "type",
          sortable: true,
        },
        {
          key: "working_title",
          label: "Working Title",
          sortable: true,
        },
        {
          key: "series",
          sortable: true,
        },
        {
          key: "levels",
          sortable: true,
        },
        {
          key: "emotion",
          sortable: true,
        },
        {
          key: "intensity",
          label: "INT",
          sortable: true,
        },
        {
          key: "status",
          label: "Last Edited",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentPaginationPage: "commons/currentPaginationPage",
      currentDataList: "commons/currentDataList",
      fieldOptionsChunked: "commons/fieldOptionsChunked",
      coloursOptions: "commons/coloursOptions",
    }),
  },
  mounted() {
    this.$store.dispatch(`commons/getFieldOptions`);
    var args = {
      limit: 25,
      type: "todo",
      status: "clip-listed",
      offset: 1,
    };

    if (this.searchStr) {
      args["search"] = this.searchStr;
    }
    if (this.sorting) {
      args["sorting"] = this.sorting;
    }

    this.fetchData(args, 1);
  },
  methods: {
    dateStatus(date) {
      return moment(date).fromNow();
    },
    openFullscreen() {
      var elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen();
      }
    },

    closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen();
      }
    },

    openAutoCue(activity) {
      this.$store.commit(`commons/setActivity`, activity);
      const activityType =
        activity.type == "stretch_flow" ? "stretch-flow" : activity.type;
      this.$router.push(`/auto-cue/${activityType}/${activity.id}`);
      this.openFullscreen();
    },

    optionValue(id, type) {
      const data =
        this.fieldOptionsChunked[type] && id
          ? this.fieldOptionsChunked[type].find((option) => option.id == id)
          : null;

      if (data) return data.label;
    },
    convertType(type) {
      return type == "stretch_flow" ? "stretch-flow" : type;
    },
    countPage() {
      if (this.activities.count)
        return Math.ceil(this.activities.count / this.limit);
    },
    fetchData(args, page) {
      this.searchResult = true;
      this.$store.commit("commons/setPreloader", true);
      this.$store.dispatch("commons/listByType", args).then(
        (res) => {
          this.activities = res;
          this.$store.commit("commons/setPreloader", false);
        },
        (error) => {
          this.$store.commit("commons/setPreloader", false);
          console.log(error);
        }
      );
      this.$store.commit("commons/setCurrentPaginationPage", page);
    },
    sortingFunc(ctx) {
      this.activities.results = [];
      this.sorting = ctx.sortDesc ? "-" : "";
      var sortby =
        ctx.sortBy == "working_title" ||
        ctx.sortBy == "type" ||
        ctx.sortBy == "created"
          ? ctx.sortBy
          : ctx.sortBy + "__label";

      this.sorting = this.sorting + sortby;

      var args = {
        limit: this.limit,
        type: "todo",
        status: "clip-listed",
        offset: this.currentPageNumber,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    page(number) {
      this.currentPageNumber = number;
      var args = {
        limit: this.limit,
        type: "todo",
        status: "clip-listed",
        offset: this.currentPageNumber,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    next() {
      this.currentPageNumber = this.currentPageNumber + 1;
      var args = {
        limit: this.limit,
        type: "todo",
        status: "clip-listed",
        offset: this.currentPageNumber,
      };
      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    prev() {
      this.currentPageNumber = this.currentPageNumber - 1;
      var args = {
        limit: this.limit,
        type: "todo",
        status: "clip-listed",
        offset: this.currentPageNumber,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    changelimit() {
      var args = {
        limit: this.limit,
        type: "todo",
        status: "clip-listed",
        offset: this.currentPageNumber,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    search() {
      var args = {
        limit: this.limit,
        type: "todo",
        status: "clip-listed",
        offset: 1,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, 1);
    },
    clearSearch() {
      if (!this.searchStr) {
        this.search();
      }
    },
    clearSearchClick() {
      this.searchStr = "";
      this.search();
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
    updateStatus(activity, status) {
      this.$store.commit("commons/setPreloader", true);
      this.$store.commit(`commons/setActivity`, activity);
      this.$store.commit(`commons/setActivityStatus`, status);
      this.$store.dispatch(`commons/updateActivity`, activity.id).then(
        (res) => {
          this.$store.commit(`commons/setSavingForm`, "Saved");

          var args = {
            limit: this.limit,
            type: "todo",
            status: "clip-listed",
            offset: this.currentPageNumber,
          };

          if (this.searchStr) {
            args["search"] = this.searchStr;
          }
          if (this.sorting) {
            args["sorting"] = this.sorting;
          }

          this.fetchData(args, this.currentPageNumber);
        },
        (error) => {
          console.log(error);
        }
      );
    },
    scriptBuilder(activity) {
      this.$store.commit("scripts/setOpened", true);
      this.$store.commit(`commons/setActivity`, activity);
      this.$store.commit("scripts/setActiveWorkout", activity.id);
      this.$store.dispatch("scripts/getCircuits", activity.id);
      this.$store.dispatch(`scripts/getAutoCueWithRests`, activity.id);
      this.$store.dispatch(
        `scripts/getAutoCueWithRestsAndCircuitDetails`,
        activity.id
      );
    },
    openActivity(activity, index) {
      this.$router.push(
        `/update-${this.convertType(activity.type)}/${activity.id}`
      );
    },

    activeColour(id) {
      return this.coloursOptions && id
        ? this.coloursOptions.find((option) => option.id == id)
        : null;
    },
  },
};
</script>
<style lang="scss">
.clip-listed {
  tbody {
    td {
      &:last-child {
        width: 500px;
        text-align: right;
        .status {
          width: 190px;
          display: inline-block;
          text-align: right;
        }
      }
    }
  }
}
</style>
<template>
  <div class="data-list clip-listed">
    <div class="filter d-flex align-items-center">
      <b-input-group>
        <b-form-input
          v-model="searchStr"
          type="text"
          placeholder="Search workouts by name, status, …"
          v-on:keyup.enter="search"
        ></b-form-input>
        <b-input-group-append>
          <b-input-group-text class="mr-2">
            <b-icon icon="search" v-if="!searchStr" />
            <b-icon
              icon="x-circle-fill"
              class="text-danger cursor-pointer"
              @click="clearSearchClick()"
              v-if="searchStr"
            />
          </b-input-group-text>
        </b-input-group-append>
      </b-input-group>
      <b-input-group-append>
        <b-button
          text="Button"
          variant="primary bg-white text-primary"
          @click="search()"
          >FILTER</b-button
        >
      </b-input-group-append>
    </div>
    <b-table
      @sort-changed="sortingFunc"
      :sticky-header="true"
      responsive
      :fields="fields"
      :items="activities.results"
      v-if="searchResult"
    >
      <!-- @row-clicked="openActivity" -->
      <template #cell(working_title)="data">
        <b
          ><a
            v-bind:href="`#/update-${convertType(data.item.type)}/${
              data.item.id
            }`"
            >{{ data.item.working_title }}</a
          ></b
        >
      </template>

      <template #cell(type)="data">
        <span
          class="badge inline-block type text-black"
          :style="{
            background: activeColour(data.item.colour)
              ? activeColour(data.item.colour).value
              : '',
          }"
          >{{ data.item.type }}
        </span>
      </template>

      <template #cell(series)="data"
        ><span>{{ optionValue(data.item.series, "SRS") }}</span></template
      >
      <template #cell(levels)="data">
        <div class="level-wrapper">
          <span v-for="level in data.item.levels" :key="level.id">
            {{ level }}
          </span>
        </div>
      </template>
      <template #cell(emotion)="data">
        <span v-if="data.item.type == 'stretch_flow'">{{
          optionValue(data.item.emotion, "STRETCHFLOW_EMO")
        }}</span>
        <span v-if="data.item.type != 'stretch_flow'">{{
          optionValue(data.item.emotion, "EMO")
        }}</span>
      </template>

      <template #cell(intensity)="data">
        <span v-if="data.item.type == 'stretch_flow'">{{
          optionValue(data.item.intensity, "STRETCHFLOW_HS")
        }}</span>
        <span v-if="data.item.type != 'stretch_flow'">{{
          optionValue(data.item.intensity, "HS")
        }}</span>
      </template>
      <template #cell(status)="data">
        <span class="timestamp">{{ dateStatus(data.item.modified) }}</span>
        <span
          class="d-inline-block text-primary text-uppercase cursor-pointer"
          @click="openAutoCue(data.item)"
          ><b>PLAY AUTO CUE</b>
        </span>
        <span
          class="
            d-inline-block
            text-secondary
            px-4
            text-uppercase
            cursor-pointer
            status
          "
          v-if="
            (data.item.filming_complete && data.item.with_equipment != null) ||
            (data.item.has_script && data.item.with_equipment != null)
          "
          :class="data.item.status == 'filmed' ? 'text-green' : ''"
          @click="updateStatus(data.item, 'filmed')"
        >
          <span
            class="check-wrapper"
            :class="data.item.status == 'filmed' ? 'active' : ''"
            ><div class="check"></div
          ></span>
          <b>Filmed</b>
        </span>
        <span
          class="text-danger status px-4"
          v-if="
            (!data.item.has_script && !data.item.filming_complete) ||
            data.item.with_equipment == null
          "
          ><b>ADD INFORMATION </b>
          <b-icon
            icon="exclamation-triangle-fill"
            scale=".9"
            variant="danger"
          ></b-icon>
        </span>
        <b-dropdown id="dropdown-right" right class="action-button">
          <template #button-content>
            <b-icon icon="three-dots" scale="2" class="cursor-pointer"></b-icon>
          </template>
          <b-dropdown-item @click="scriptBuilder(data.item)"
            >Edit script</b-dropdown-item
          >
          <b-dropdown-item @click="updateStatus(data.item, 'ready-to-film')"
            >Move back to "Ready to film"</b-dropdown-item
          >
        </b-dropdown>
      </template>
    </b-table>

    <h2 v-if="!searchResult" class="text-center py-5">
      No "{{ searchStr }} " found
    </h2>

    <div
      class="
        pagination-wrapper
        d-flex
        justify-content-between
        align-items-center
        w-100
      "
      v-if="searchResult"
    >
      <div class="total">{{ activities.count }} results</div>
      <div class="pagination">
        <ul
          role="menubar"
          aria-disabled="false"
          aria-label="Pagination"
          class="pagination b-pagination"
          v-if="countPage() != 1"
        >
          <li
            role="presentation"
            aria-hidden="true"
            class="page-item cursor-pointer"
            v-if="activities.previous"
          >
            <span
              aria-label="Go to previous page"
              class="page-link text-primary"
              @click="prev()"
            >
              <b-icon icon="chevron-left" aria-hidden="true"></b-icon
            ></span>
          </li>
          <li
            class="page-item"
            v-for="item in countPage()"
            :key="item"
            :class="item == currentPaginationPage ? 'active' : ''"
          >
            <button class="page-link" @click="page(item)">{{ item }}</button>
          </li>
          <li
            role="presentation"
            aria-hidden="true"
            class="page-item cursor-pointer"
            v-if="activities.next"
          >
            <span
              aria-label="Go to next page"
              class="page-link text-primary"
              @click="next()"
            >
              <b-icon icon="chevron-right" aria-hidden="true"></b-icon
            ></span>
          </li>
        </ul>
      </div>
      <div
        class="
          dropdown-pagination
          d-flex
          justify-content-end
          align-items-center
        "
      >
        <b-form-group class="select">
          <b-form-select v-model="limit" @change="changelimit()">
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </b-form-select>
        </b-form-group>
        Per page
      </div>
    </div>
  </div>
</template>